import SectionCustomerReviews from './SectionCustomerReviews';
export default SectionCustomerReviews;
